export default {"src":"/_next/static/media/chainlink.eb1a4e56.svg","height":44,"width":38,"blurWidth":0,"blurHeight":0};